import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const hash = location.hash; // e.g. #session_id=abc123
    const sessionId = hash.replace("#session_id=", "").split("&")[0];

    if (!sessionId) {
      navigate("/login");
      return;
    }

    const exchange = async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        login(data);
        navigate(data.onboarding_complete ? "/lobby" : "/onboarding", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    exchange();
  }, []);

  return (
    <div className="min-h-screen bg-[#07070B] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 rounded-full border-2 border-cyan-500/30 border-t-cyan-400 animate-spin" />
        <p className="text-slate-400 font-mono text-sm tracking-widest uppercase">Connecting you in...</p>
      </div>
    </div>
  );
}
